import styled from 'styled-components';

import { BREAK_POINTS } from '../../../../consts/styleDedupe';
import { COLOURS } from '../../../../consts/style';
import { FadeBanner } from '../../../../consts/style';

interface IBannerProps {
  backgroundColour: string;
  backgroundImage: string;
  postcodeEntry: boolean;
}

interface IDescriptionProps {
  noMargin?: boolean;
}

export const BannerContainer = styled.div`
  display: flex;
  width: 100%;
  z-index: 0;
  margin: 0 auto;

  color: white;
  text-align: center;
  background-color: ${COLOURS.PRIMARY.ORANGE};
  ${FadeBanner}

  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    text-align: left;
    position: relative;
  }

  @media screen and (min-width: ${BREAK_POINTS.Min.LG}) {
    min-height: 404px;
    background-image: ${(p: IBannerProps) =>
      p.backgroundImage ? 'url(' + p.backgroundImage + ')' : ''};
    background-repeat: no-repeat;
    background-position: bottom -20px right -164px;
    background-size: auto 404px;
  }
  @media screen and (min-width: ${BREAK_POINTS.Min.XL}) {
    background-position: bottom center;
  }
` as any;

export const ContentContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: ${508 + 16 * 2}px;

  @media (min-width: ${BREAK_POINTS.Min.MD}) {
    width: 100%;
    max-width: inherit;
  }

  @media (min-width: ${BREAK_POINTS.Min.XL}) {
    width: 1140px;
  }
`;

export const ContentSpacing = styled.div`
  margin: 0;
  padding: 64px 24px;

  @media (min-width: ${BREAK_POINTS.Min.MD}) {
    padding: 64px 40px ${64 + 32}px;
  }
  @media (min-width: ${BREAK_POINTS.Min.LG}) {
    padding: 64px 40px ${64 + 32}px;
    max-width: 600px;
  }

  @media (min-width: ${BREAK_POINTS.Min.XL}) {
    padding: 64px 0 ${64 + 32}px;
  }

  &.content-spacing--postcode {
    padding: 48px 16px;

    @media (min-width: ${BREAK_POINTS.Min.MD}) {
      padding-bottom: ${48 + 32}px;
    }

    @media (min-width: ${BREAK_POINTS.Min.LG}) {
      max-width: 530px;
      padding: 64px 32px ${64 + 32}px;
    }

    @media (min-width: ${BREAK_POINTS.Min.XL}) {
      max-width: 600px;
    }
  }
`;

export const Title = styled.h2`
  font-weight: 700;
  font-size: 32px;
  line-height: 1.166;
  margin: 0 0 16px 0;

  @media (min-width: ${BREAK_POINTS.Min.LG}) {
    font-size: 40px;
    line-height: 1.25;
  }

  &.heading--postcode {
    font-size: 24px;

    @media (min-width: ${BREAK_POINTS.Min.LG}) {
      font-size: 32px;
    }
  }
` as any;

export const Description = styled.p`
  font-size: 20px;
  line-height: 32px;
  margin: ${(p: IDescriptionProps) => (p.noMargin ? '0' : '0 0 32px 0')};
  & > span {
    font-size: 20px;
    line-height: 32px;
    color: white;
    font-weight: 300;

    a:hover,
    a:focus {
      color: white;
    }
  }
` as any;

export const Disclaimer = styled.p`
  margin: 32px 0 0 0;
  & > span {
    font-size: 16px;
    line-height: 24px;
    color: white;
    font-weight: 300;

    a:hover,
    a:focus {
      color: white;
    }
  }
` as any;
